export const getOrderDetailsCardInfo = (selectedCounter: any) => {
  let response: any = {};

  response = {
    "Doctor Full Name": selectedCounter?.counter_location?.counter_hdr_id?.counter_name || "-",
    "Counter Type": selectedCounter?.drph_lnk_type?.dr_ph_lnk_code || "-",

    "Mobile Number": selectedCounter?.mobile || "-",
    "MCI Regn. No.": selectedCounter?.counter_location?.counter_hdr_id?.counter_name || "-",

    "Clinic Name": selectedCounter?.counter_location?.clinic_name || "-",
    "Email ID": selectedCounter?.counter_location?.counter_hdr_id?.email || "-",

    City: selectedCounter?.counter_location?.address || "-",
    Location: selectedCounter?.counter_location?.address || "-",

    Speciality: selectedCounter?.counter_location?.counter_hdr_id?.speciality_id?.speciality_desc || "-",
    // "Pin Code": selectedCounter?.counter_location?.pincode || "-",
    // "Cluster Name": selectedCounter?.counter_stockist_lnk?.[0]?.stockist_cluster?.clusterCode?.cluster_name || "-",
    "Medvol Stockist Code": selectedCounter?.counter_stockist_lnk?.[0]?.stockist_cluster?.stockistCompanyLnk?.stockist?.medvol_code || "-",
    Stockist: selectedCounter?.counter_stockist_lnk?.[0]?.stockist_cluster?.stockistCompanyLnk?.stockist?.firm_name || "-",
  };

  return response;
};

export const getDefaultStockistInfo = (selectedCounter: any) => {
  let response: Record<string, string> = {};

  selectedCounter?.counter_stockist_lnk?.forEach((item: any) => {
    const clusterName = item?.stockist_cluster?.clusterCode?.cluster_name;
    const clusterStockist = item?.stockist_cluster?.stockistCompanyLnk?.stockist?.owner_name;

    if (clusterName && clusterStockist) {
      response[clusterName] = clusterStockist;
    }
  });

  response = {
    ...response,
  };

  return response;
};

export const getOrderInvoiceCardInfo = (fuidData: any) => {
  let response: any = {};

  response = {
    "Entered on": fuidData?.invoice?.created_date
      ? `${new Date(fuidData?.invoice?.created_date).toLocaleDateString("en-GB", {
          day: "numeric",
          month: "long",
          year: "numeric",
        })}, ${new Date(fuidData?.invoice?.created_date).toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })}`
      : "-",

    "Approved on": fuidData?.invoice?.updated_date
      ? `${new Date(fuidData?.invoice?.updated_date).toLocaleDateString("en-GB", {
          day: "numeric",
          month: "long",
          year: "numeric",
        })}, ${new Date(fuidData?.invoice?.updated_date).toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })}`
      : "-",

    "E-Invoice Applicable": fuidData?.invoice?.stockistInvoiceAttachment?.is_einv_applicable || "-",
    "Entered by": fuidData?.invoice?.entered_by?.user_name || "-",

    "Approved by": fuidData?.invoice?.approved_by?.user_name || "-",
    "IR No.": fuidData?.invoice?.irn || "-",
  };

  return response;
};

export const getOrderInvoiceAcknowledgementInfo = (fuidData: any) => {
  let response: any = {};

  response = {
    "Acknowledged on": fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.uploaded_date
      ? `${new Date(fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.uploaded_date).toLocaleDateString("en-GB", {
          day: "numeric",
          month: "long",
          year: "numeric",
        })}, ${new Date(fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.uploaded_date).toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })}`
      : "-",
    "Verified on": fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.verified_date
      ? `${new Date(fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.verified_date).toLocaleDateString("en-GB", {
          day: "numeric",
          month: "long",
          year: "numeric",
        })}`
      : "-",
    Type: "Image / Screen",

    "Acknowledged by.": fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.uploaded_by_name,

    // "Acknowledged by": fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.uploaded_by_name,
    "Verified by": fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.verified_by_name,
  };

  return response;
};

export const getOrderInfoHomeScreenData = (orderDetailsFilteredData: any) => {
  let response: any = {};
  const orderDetailsFiltered = orderDetailsFilteredData?.[0];

  response = {
    "Counter name": orderDetailsFiltered?.counterInfo?.counter_name || "-",
    Location: `${orderDetailsFiltered?.latitude},${orderDetailsFiltered?.longitude}`,
    "Order Mode": orderDetailsFiltered?.order_mode,
    "Order Type":
      orderDetailsFiltered?.cndn_remarks_code_int == "1"
        ? "Regular Order"
        : orderDetailsFiltered?.cndn_remarks_code_int == "2"
          ? "Supply Against Order - No Replenishment"
          : orderDetailsFiltered?.cndn_remarks_code_int == "3"
            ? "Credit Note - No Replenishment"
            : orderDetailsFiltered?.cndn_remarks_code_int == "4"
              ? "POB"
              : "-",
    "Counter code": orderDetailsFiltered?.counter_code,
    City: "-",
    "Order Initiated date": orderDetailsFiltered?.created_date
      ? `${new Date(orderDetailsFiltered?.created_date).toLocaleDateString("en-GB", {
          day: "numeric",
          month: "long",
          year: "numeric",
        })}, ${new Date(orderDetailsFiltered?.created_date).toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })}`
      : "-",
    "Counter location": "-",
    "Division name": orderDetailsFiltered?.division_name,
    "Order Placed date": orderDetailsFiltered?.orderStatusHdr?.modified_date
      ? `${new Date(orderDetailsFiltered?.orderStatusHdr?.modified_date).toLocaleDateString("en-GB", {
          day: "numeric",
          month: "long",
          year: "numeric",
        })}, ${new Date(orderDetailsFiltered?.orderStatusHdr?.modified_date).toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })}`
      : "-",
    "Clinic name": "-",
    "Stockist name": orderDetailsFiltered?.stockist_name,
    "Order Value": orderDetailsFiltered?.billed_price,
    "Link Type": orderDetailsFiltered?.counterInfo?.counterLinkType,
    "Stockist code": orderDetailsFiltered?.company_stockist_code,
    "Ordered by": "-",
    "Cash Discount %": orderDetailsFiltered?.order_cash_discount_perc,
  };

  return response;
};

export const getInvoiceAcknowledgementFullInfo = (fuidData: any) => {
  let response: any = {};

  response = {
    "Uploaded by": fuidData?.invoice?.stockistInvoiceAttachment?.uploader_name,
    "Uploaded on": fuidData?.invoice?.stockistInvoiceAttachment?.updated_date
      ? `${new Date(fuidData?.invoice?.stockistInvoiceAttachment?.updated_date).toLocaleDateString("en-GB", {
          day: "numeric",
          month: "long",
          year: "numeric",
        })}`
      : "-",
    "Invoice No.": fuidData?.invoice?.invoice_number,
    "Invoice Date": fuidData?.invoice?.created_date
      ? `${new Date(fuidData?.invoice?.created_date).toLocaleDateString("en-GB", {
          day: "numeric",
          month: "long",
          year: "numeric",
        })}`
      : "-",
    "Acknowledged on": fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.uploaded_date
      ? `${new Date(fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.uploaded_date).toLocaleDateString("en-GB", {
          day: "numeric",
          month: "long",
          year: "numeric",
        })}, ${new Date(fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.uploaded_date).toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })}`
      : "-",
    "Acknowledged by.": fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.uploaded_by_name,
    "Verified on": fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.verified_date
      ? `${new Date(fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.verified_date).toLocaleDateString("en-GB", {
          day: "numeric",
          month: "long",
          year: "numeric",
        })}`
      : "-",
    "Verified by": fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.verified_by_name,
    Type: "Image / Screen",
    // "Acknowledged by": fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.uploaded_by_name,
  };

  return response;
};
